// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.log-pre[data-v-19a56bfe] {\r\n    max-height: 200px;\r\n    overflow: auto;\r\n    background: #fff;\r\n    border: 1px solid #eee;\r\n    padding: 6px;\r\n    margin: 4px 0 0;\r\n    font-size: 11px;\r\n    white-space: pre-wrap;\r\n    word-break: break-all;\n}\n.log-pre[data-v-19a56bfe],\r\ndetails summary[data-v-19a56bfe] {\r\n    cursor: pointer;\n}\ndetails summary[data-v-19a56bfe] {\r\n    font-size: 12px;\r\n    color: #007bff;\n}\r\n", ""]);
// Exports
module.exports = exports;
